import { Button, Input, Form, Drawer, Select, InputNumber, message } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from "axios";

import config from "../../utils/config.js";
import endpoints from "../../utils/endpoints.js";

import Media from "../Media/media.js";

export default function Create({ open, close, sponsorsTiers }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);

  const [form] = Form.useForm();

  function submit(values) {
    setIsButtonLoading(true);

    axios
      .post(endpoints.sponsor.create, {
        data: values,
      })
      .then((res) => {
        closeDrawer();
        message.success("Patrocinador foi adicionado com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeDrawer() {
    close();
    setIsButtonLoading(false);
    form.resetFields();
  }

  function openMedia(k) {
    setMediaKey(k);
    setIsOpenMedia(true);
  }

  function closeMedia(res) {
    if (res) {
      form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setIsOpenMedia(false);
  }

  return (
    <Drawer
      width={800}
      title={`Adicionar patrocinador`}
      open={open}
      onClose={close}
      maskClosable={false}
      extra={[
        <Button className="mr-2" size="large" type="primary" onClick={form.submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Adicionar
        </Button>,
        <Button size="large" onClick={close}>
          Cancelar
        </Button>,
      ]}
    >
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <Form form={form} id="create-sponsor" layout="vertical" onFinish={submit}>
        <Form.Item name="type" label="Tipo" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <Select
            size="large"
            placeholder="Tipo de patrocinador..."
            options={[
              { id: "Científico", name: "Científico" },
              { id: "Institucional", name: "Institucional" },
              { id: "Patrocinador", name: "Patrocinador" },
            ].map((value, index) => ({
              value: value.id,
              label: value.name,
            }))}
          ></Select>
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.img !== currentValues.img}>
          {({ getFieldValue }) => {
            return (
              <div className="relative">
                <p className="pb-[8px]">Imagem</p>
                <div
                  className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                  onClick={() => openMedia("img")}
                  style={{
                    backgroundImage: `url(${config.server_ip}media/${getFieldValue("img")})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  {!getFieldValue("img") ? (
                    <div className="flex justify-center items-center flex-col p-10">
                      <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                    </div>
                  ) : null}
                </div>

                <Form.Item name={"img"} hidden>
                  <Input />
                </Form.Item>
              </div>
            );
          }}
        </Form.Item>
        <Form.Item name="name" label="Nome" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <Input size="large" placeholder="Nome..." />
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.type !== currentValues.type}>
          {({ getFieldValue }) => (
            <Form.Item name="id_tier" label="Tipo" rules={[{ required: getFieldValue("type") === "Patrocinador", message: "Este é um campo obrigatório" }]}>
              <Select
                size="large"
                placeholder="Tier de patrocinador..."
                options={sponsorsTiers.map((value, index) => ({
                  value: value.id,
                  label: value.name,
                }))}
              ></Select>
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item name="pos" label="Posição (nº)" rules={[{ required: true, message: "Este é um campo obrigatório" }]}>
          <InputNumber size="large" min={1} placeholder="1" />
        </Form.Item>
        <Form.Item name="link" label="Link">
          <Input size="large" placeholder="Link..." />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
